import SpeakerRelations from "@/models/SpeakerRelations";
import {addSpeakerDoc, getSpeakerDoc, setSpeakerDoc, updateEventDoc, updateSpeakerDoc} from "@/shared/firebase_utils";

class Speaker {
    constructor({
                    firstName = "",
                    lastName = "",
                    email = "",
                    invitationLink = "",
                    displayImageURL = "",
                    jobTitle = "",
                    businessName = "",
                    bio = "",
                    associatedSpeakerSessions = [],
                    businessCardId = "",
                    speakerId = "",
                    facebook = "",
                    instagram = "",
                    linkedin = "",
                    twitter = "",
                    youtube = "",
                    podcast = "",
                    speakerRelations = [],
                    status = "",
                    evokeAGSpeakerId = null
                }) {
        (this.firstName = firstName || ""),
            (this.lastName = lastName || ""),
            (this.email = email || ""),
            (this.displayImageURL = displayImageURL || ""),
            (this.jobTitle = jobTitle || ""),
            (this.businessName = businessName || ""),
            (this.bio = bio || ""),
            (this.associatedSpeakerSessions = associatedSpeakerSessions || []),
            (this.businessCardId = businessCardId || ""),
            (this.speakerId = speakerId || ""),
            (this.facebook = facebook || ""),
            (this.instagram = instagram || ""),
            (this.linkedin = linkedin || ""),
            (this.twitter = twitter || ""),
            (this.youtube = youtube || ""),
            (this.podcast = podcast || ""),
            (this.invitationLink = invitationLink || ""),
            (this.speakerRelations = speakerRelations || []);
            (this.evokeAGSpeakerId = evokeAGSpeakerId || null),
            (this.status = status || "");
    }

    static fromObject(speaker) {
        return new Speaker({
            firstName: speaker.firstName || "",
            lastName: speaker.lastName || "",
            email: speaker.email || "",
            displayImageURL: speaker.displayImageURL || "",
            jobTitle: speaker.jobTitle || "",
            businessName: speaker.businessName || "",
            bio: speaker.bio || false,
            associatedSpeakerSessions: speaker.associatedSpeakerSessions || [],
            businessCardId: speaker.businessCardId || "",
            speakerId: speaker.speakerId || "",
            facebook: speaker.facebook || "",
            instagram: speaker.instagram || "",
            linkedin: speaker.linkedin || "",
            twitter: speaker.twitter || "",
            youtube: speaker.youtube || "",
            podcast: speaker.podcast || "",
            invitationLink: speaker.invitationLink || "",
            speakerRelations: speaker.speakerRelations?.map((speakerRelation) => SpeakerRelations.fromObject(speakerRelation)) || [],
            evokeAGSpeakerId: speaker.evokeAGSpeakerId || null,
            status: speaker.status || ""
        });
    }

    static fromEventObject(speaker) {
        return new Speaker({
            firstName: speaker.firstName || "",
            lastName: speaker.lastName || "",
            displayImageURL: speaker.displayImageURL || "",
            jobTitle: speaker.jobTitle || "",
            businessName: speaker.businessName || "",
            bio: speaker.bio || false,
            associatedSpeakerSessions: speaker.associatedSpeakerSessions || [],
            businessCardId: speaker.businessCardId || "",
            speakerId: speaker.speakerId || "",
            email: speaker.email || "",
            status: speaker.status || ""
        });
    }

    toObject() {
        return {
            firstName: this.firstName || "",
            lastName: this.lastName || "",
            email: this.email || "",
            displayImageURL: this.displayImageURL || "",
            jobTitle: this.jobTitle || "",
            businessName: this.businessName || "",
            bio: this.bio || false,
            associatedSpeakerSessions: this.associatedSpeakerSessions || [],
            businessCardId: this.businessCardId || "",
            speakerId: this.speakerId || "",
            facebook: this.facebook || "",
            instagram: this.instagram || "",
            linkedin: this.linkedin || "",
            twitter: this.twitter || "",
            youtube: this.youtube || "",
            podcast: this.podcast || "",
            invitationLink: this.invitationLink || "",
            speakerRelations: this.speakerRelations?.map((speakerRelation) => speakerRelation.toObject()) || [],
            evokeAGSpeakerId: this.evokeAGSpeakerId || null,
            status: this.status || ""

        }
    }

toEventObject() {
        console.log("to event object", this.status);
        return {
            firstName: this.firstName || "",
            lastName: this.lastName || "",
            email: this.email || "",
            displayImageURL: this.displayImageURL || "",
            jobTitle: this.jobTitle || "",
            businessName: this.businessName || "",
            bio: this.bio || false,
            associatedSpeakerSessions: this.associatedSpeakerSessions || [],
            businessCardId: this.businessCardId || "",
            speakerId: this.speakerId || "",
            status: this.status || ""
        }
    }

    async save() {
        try {
            if (this.speakerId !== null && this.speakerId !== "" && this.speakerId !== undefined) {
                await setSpeakerDoc(this.speakerId, this.toObject(), {merge: true});
            } else {
                let docRef = await addSpeakerDoc(this.toObject());
                this.speakerId = docRef.id;
                await updateSpeakerDoc(this.speakerId, {speakerId: docRef.id});
            }
            return this.speakerId;
        } catch (error) {
            console.log("Error saving speaker: ", error);
        }
    }

    async updateSpeaker(eventSpeakers, eventId, isSpeakerDetails = true) {
        try {
            let speaker = this;
            if (!isSpeakerDetails || this.email == "" || this.email == null || this.email == undefined) {
                speaker = await this.getSpeaker();
            }
            speaker.status = this.status;
            if (speaker.speakerId != null && speaker.speakerId != "" && speaker.speakerId != undefined) {
                await setSpeakerDoc(speaker.speakerId, speaker.toObject(), {merge: true});
                let speakerIndex = eventSpeakers.findIndex(
                    (e) => e.speakerId == speaker.speakerId
                );
                if (speakerIndex != -1) {
                    eventSpeakers.splice(
                        speakerIndex,
                        1,
                        speaker
                    );
                    await updateEventDoc(eventId, {speakers: eventSpeakers?.map((speaker) => speaker.toEventObject())});
                }
            }
        } catch (error) {
            console.log("Error saving speaker: ", error);
        }
    }

    async getSpeaker() {
        try {

            const doc = await getSpeakerDoc(this.speakerId);
            if (doc.exists) {
                return Speaker.fromObject(doc.data());
            } else {
                throw new Error("Speaker not found");
            }
        } catch (error) {
            console.error("Error getting speaker document:", error);
        }
    }

    async doesDocumentExist() {
        if (this.speakerId == null || this.speakerId == "") {
            return false;
        } else {
            try {
                const doc = await getSpeakerDoc(this.speakerId);
                if (doc.exists) {
                    return true;
                } else {
                    return false;
                }
            } catch (error) {
                console.log("Error getting speaker document:", error);
                return false;
            }
        }
    }
}

export default Speaker;